export const updateProfileFields = (state,action) =>{
    let currentUser = state.currentUser
    let data = JSON.parse(action.data)
    currentUser.name = data.name
    return Object.assign({} , state, {currentUser})
}


// WEBPACK FOOTER //
// ./src/Store/Reducers/ProfileReducer.js